var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"additional-counselors"},[_c('ol',_vm._l((_vm.tagCloud),function(item,idx){return _c('li',{key:idx},[_c('link-button',{staticClass:"btn1",attrs:{"link":null,"buttonFace":("#" + (item.display_label)),"design":"ghost"},on:{"click":function($event){_vm.$emit('click', item.id)}}})],1)}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d08c1c8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Toppage/section/TagCloud.vue
// module id = null
// module chunks = 